var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v5-spinner-ripple",style:({ 'width':_vm.size, 'height':_vm.size})},[_c('div'),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }